import {
    WizerMagicLinkResponse,
    BadRequestResponse,
    BadRequestResponseData,
} from '@atbay/productivity-integrations-node-sdk'
import { AxiosError, AxiosResponse } from 'axios'
import { ProductivityIntegrationsClient } from '@core/api/productivity-integration-client'
import { BaseService } from '@core/base/service/base-service'
import { keyErrorInfo } from '@core/modules/issues/constants'

export const ProductivityIntegrationsService =
    new (class ProductivityIntegrationsService extends BaseService {
        private readonly client = ProductivityIntegrationsClient

        constructor() {
            super('productivity.integrations.service')
        }

        private resolveWizerErrorType(status?: number): TWizerErrorType {
            if (status === 409) return 'ACCOUNT_ALREADY_EXISTS'
            if (status === 422) return 'INVALID_COMPANY_ID'
            if (status === 400) return 'REGISTRATION_NOT_COMPLETE'
            return 'GENERAL_ERROR'
        }

        async getWizerIntegration() {
            const [error, result] = await this.request(() =>
                this.http.get(
                    `/api/accounts/${this.accountId}/wizer/integration`,
                    {}
                )
            )

            if (error) {
                console.log('error get wizer integration', error)
                return
            }
            return result?.data?.data
        }

        async generateWizerMagicLink(): Promise<TMagicLinkDetails> {
            const [error, result] = await this.request<
                AxiosResponse<WizerMagicLinkResponse>,
                AxiosError<BadRequestResponse>
            >(() =>
                this.http.post(
                    `/api/accounts/${this.accountId}/wizer/magic-link`,
                    {}
                )
            )

            if (error) {
                const res = error.response?.data as BadRequestResponseData
                console.log(error)
                const status = error?.response?.status

                return {
                    error:
                        status === 409 || status === 400 || status === 422
                            ? res?.detail
                            : keyErrorInfo.generalApiError.message,
                    errorType: this.resolveWizerErrorType(status),
                }
            }
            return { link: result?.data?.data?.magic_link }
        }
    })()
